import { regularPeriodCount, Sport } from './sport';

// Overtime length when a game has none set. Mirrors
// server/src/utils/game-periods.util.js.
const DEFAULT_OVERTIME_LENGTH_IN_MINUTES = 5;

// Game time in seconds at which a period starts: the sport's regular periods
// last periodLengthInMinutes, every period after them overtimeLengthInMinutes.
export function periodStartGameTime(
  period: string,
  periodLengthInMinutes: number,
  sport: Sport,
  overtimeLengthInMinutes = DEFAULT_OVERTIME_LENGTH_IN_MINUTES
): number {
  const periodNumber = parseInt(period, 10);
  const regularCount = regularPeriodCount(sport);
  if (periodNumber <= regularCount) {
    return (periodNumber - 1) * periodLengthInMinutes * 60;
  }
  return (
    regularCount * periodLengthInMinutes * 60 +
    (periodNumber - 1 - regularCount) * overtimeLengthInMinutes * 60
  );
}

export function periodEndGameTime(
  period: string,
  periodLengthInMinutes: number,
  sport: Sport,
  overtimeLengthInMinutes = DEFAULT_OVERTIME_LENGTH_IN_MINUTES
): number {
  return periodStartGameTime(
    String(parseInt(period, 10) + 1),
    periodLengthInMinutes,
    sport,
    overtimeLengthInMinutes
  );
}
